import { render, staticRenderFns } from "./SmsTemplates.vue?vue&type=template&id=5d99ad2d&scoped=true"
import script from "./SmsTemplates.vue?vue&type=script&lang=js"
export * from "./SmsTemplates.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplates.vue?vue&type=style&index=0&id=5d99ad2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99ad2d",
  null
  
)

export default component.exports